/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import DeleteModal from '../../deleteComponent/deleteModal'
import DeleteAxios from '../../axiosComponent/deleteAxios'
import EditModal from '../../commonComponent/editModal'
import FormikEditTyrePosition from './editTyrePosition'
function TyreActionButton(props) {
    const [editModal, setEditModal] = useState(false)
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)
    let handleEditClose = () => {
        setEditModal(false)
    }
    let handleClose = () => {
        setopenBox(false)
    }
    let handleDelete = () => {
        setsuccess(true)
        let id = props.data.id
        DeleteAxios({
            url: `masters/tyreposition/${id}`,
            deleteItems: {
                positionId: id
            },
            deleted: (data) => {
                if (data && data.status === 200) {
                    setTimeout(() => {
                        setsuccess(false)
                        props.agGridReact.props.reload(true)
                    }, 500);
                } else {
                    alert(data.message)
                }
            },
        })
    }
    let handleOpenEdit = (e) => {
        setEditModal(true)
    }
    let handleOpenDelete = (e) => {
        setopenBox(true)
    }
    let mainData = props.data
    return (
        <>
            <Button disabled={mainData && mainData.customerNo === 0 ? true : false} onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            <Button disabled={mainData && mainData.customerNo === 0 ? true : false} onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal isloading={success} open={openBox} onClose={handleClose} handleDelete={handleDelete} />
            {/* <EditModal size="mini" openBox={editModal} handleClose={handleEditClose}>
                <FormikEditJobcardType handleClose={handleEditClose} jobCardTypeCode={jobCardTypeCode} jobCardType={jobCardType} jbTypeId={Id} />
            </EditModal> */}
            <EditModal className="p-overflow-visible" closeOnDimmerClick={false} size="mini" open={editModal} onClose={handleEditClose}>
                <FormikEditTyrePosition tyres={props.data} getUpdate={props.agGridReact.props} handleClose={handleEditClose} />
            </EditModal>
        </>
    )
}

export default TyreActionButton
